import { Currency } from '../../../constants';

export type CreatePaymentIntentRequest = {
  amount: number;
  currency: Currency;
  description?: string;
  receiptEmail?: string;
  metadata?: Record<string, string>;
};
export type UpdatePaymentIntentRequest = {
  stripePaymentIntentId: string;
  amount: number;
  currency: Currency;
  customer?: string;
  description?: string;
  receiptEmail?: string;
  paymentMethod?: string;
  metadata?: Record<string, string>;
};

export type CreatePaymentIntentResponse = {
  id: string;
  clientSecret: string;
  status: string;
  amount: number;
  currency: string;
};

export type UpdatePaymentIntentResponse = {
  id: string;
  clientSecret: string;
  status: string;
  amount: number;
  currency: string;
};
